import { z } from "zod";

const SubscriberSummarySchema = z.object({}).strict();

export default SubscriberSummarySchema;
